import React, { useState } from "react";
import { useBoxFiltros } from "../Helper/useBox";
import { GetKey } from "../Actions/GetContainer";
import request from "../../../Helpers/API";
import { GetFechas, GetFechasSemanal } from "../Helper/GetFechas";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { BoxFiltros } from "../Helper/BoxFiltros";
import { FlujoEfectivoMensual } from "./FlujoEfectivoMensual";
import { FlujoEfectivoSemanal } from "./FlujoEfectivoSemanal";

export const FlujoEfectivoScreen = () => {
  const [state, setState] = useState({
    subtitulo: "",
    data: [],
  });
  const [boxstate, setBoxState] = useBoxFiltros();
  const [data, setData] = useState([]);
  const handdleBoxClick = () => {
    return new Promise((res, req) => {
      if (boxstate.filtrado === "mensual") {
        if (
          boxstate.ejercicioinicio === undefined ||
          boxstate.ejercicioinicio === null ||
          boxstate.ejercicioinicio === "" ||
          boxstate.ejercicioinicio === "0" ||
          boxstate.ejercicioinicio === 0
        ) {
          req("Favor de agregar el ejercicio de inicio");
          return;
        }
        if (
          boxstate.periodoinicio === undefined ||
          boxstate.periodoinicio === null ||
          boxstate.periodoinicio === "" ||
          boxstate.periodoinicio === "0" ||
          boxstate.periodoinicio === 0
        ) {
          req("Favor de agregar el periodo de inicio");
          return;
        }
        if (
          boxstate.ejerciciofin === undefined ||
          boxstate.ejerciciofin === null ||
          boxstate.ejerciciofin === "" ||
          boxstate.ejerciciofin === "0" ||
          boxstate.ejerciciofin === 0
        ) {
          req("Favor de agregar el ejercicio fin");
          return;
        } else if (
          Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
        ) {
          req(
            "El ejercicio de inicio debe ser menor o igual al ejercicio final"
          );
          return;
        }
        if (
          boxstate.periodofin === undefined ||
          boxstate.periodofin === null ||
          boxstate.periodofin === "" ||
          boxstate.periodofin === "0" ||
          boxstate.periodofin === 0
        ) {
          req("Favor de indicar el periodo final");
          return;
        } else if (
          Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
          Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
        ) {
          req("El periodo de inicio no puede ser mayor al periodo fin");
          return;
        }
      } else if (boxstate.filtrado === "semanal") {
        if (
          boxstate.ejercicio === undefined ||
          boxstate.ejercicio === null ||
          boxstate.ejercicio === "" ||
          boxstate.ejercicio === "0" ||
          boxstate.ejercicio === 0
        ) {
          req("Favor de agregar el ejercicio");
          return;
        }
        if (
          boxstate.periodo === undefined ||
          boxstate.periodo === null ||
          boxstate.periodo === "" ||
          boxstate.periodo === "0" ||
          boxstate.periodo === 0
        ) {
          req("Favor de agregar el periodo");
          return;
        }
      }

      const post = {
        EjercicioInicio: Number(boxstate.ejercicioinicio),
        PeriodoInicio: Number(boxstate.periodoinicio),
        EjercicioFin: Number(boxstate.ejerciciofin),
        PeriodoFin: Number(boxstate.periodofin),
        ejercicio: Number(boxstate.ejercicio),
        periodo: Number(boxstate.periodo),
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
        sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
      };

      if (boxstate.filtrado === "mensual") {
        request
          .post("FELineaNegocio/GetEsquemaByLineadeNegocio", post)
          .then((result) => {
            res("Consulta realizada con exito");
            setState({
              ...state,
              data: result,
              subtitulo: GetFechas(boxstate),
            });
          })
          .catch((err) => req(err));
      } else if (boxstate.filtrado === "semanal") {
        request
        .get(`CargaFlujoEfectivoSemanal/FlujoEfectivo?ejercicio=${boxstate.ejercicio}&periodo=${boxstate.periodo}`)
          .then((result) => {
            res("Consulta realizada con exito");
            setData(result);
            setState({
              ...state,
              data: result,
              subtitulo: GetFechasSemanal(boxstate),
            });
          })
          .catch((err) => req(err));
      }
    });
  };

  let flujoEfectivoComponent;
  if (boxstate.filtrado === "mensual") {
    flujoEfectivoComponent = <FlujoEfectivoMensual data={state.data} />;
  } else if (boxstate.filtrado === "semanal") {
    flujoEfectivoComponent = <FlujoEfectivoSemanal data={state.data} />;
  }

  return (
    <div id="esquema-financiero">
      <BoxFiltros
        boxState={boxstate}
        onBoxChange={setBoxState}
        BoxClick={handdleBoxClick}
        titulo="FLUJO DE EFECTIVO"
        mostrardepartamento={false}
        subtitulo={state.subtitulo}
        titulo_filtro="FLUJO DE EFECTIVO"
      ></BoxFiltros>
      {flujoEfectivoComponent}
    </div>
  );
};
